import styled from 'styled-components'

export const Container = styled.section`
    float: left;
    width: 100%;
    position: relative;
    padding: 150px 30px;
    background: url(${props => props.bgDesktop }) center center #000 no-repeat;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 900px) {
        background: url(${props => props.bgMobile }) center bottom #000 no-repeat;
        background-size: 100% auto;
        flex-direction: column-reverse;
        padding: 50px 20px;
    }
`

export const BoxCol6 = styled.div`
    float: left;
    width: 50%;
    padding: 0 15px;
    text-align: center;

    @media (max-width: 900px) {
        width: 100%;
    }
`

export const ImagemPrincipal = styled.img`
    max-width: 90%;
`

export const TextoBanner = styled.span`
    float: left;
    width: 100%;
    color: #fff;
    font-size: 16px;
    line-height: 26px;
    margin-bottom: 140px;

    strong {
        color: #FFEBAF;
    }

    @media (max-width: 1000px) {
        br {
            display: none;
        }
    }

    @media (max-width: 900px) {
        margin-bottom: 600px;
    }

    @media (max-width: 700px) {
        margin-bottom: 500px;
    }

    @media (max-width: 550px) {
        margin-bottom: 400px;
    }

    @media (max-width: 400px) {
        margin-bottom: 300px;
    }
`

export const BoxAviso = styled.div`
    border-radius: 24px;
    border: 3px solid #C39348;
    background: linear-gradient(180deg, #2B2B2B 0%, #000 100%);
    padding: 30px;
    display: inline-block;
    max-width: 60%;
    margin: 0 auto;

    @media (max-width: 1650px) {
        max-width: 100%;
    }

    @media (max-width: 900px) {
        margin-bottom: 50px;
    }

    @media (max-width: 768px) {
        padding: 20px;
    }
`

export const TituloAviso = styled.span`
    float: left;
    width: 100%;
    color: #F09C00;
    font-size: 40px;
    font-weight: 700;

    @media (max-width: 1650px) {
        font-size: 32px;
    }

    @media (max-width: 768px) {
        font-size: 28px;
    }
`

export const TextoAviso = styled.span`
    float: left;
    width: 100%;
    color: #F09C00;
    font-size: 20px;
    line-height: 30px;
    margin-top: 20px;

    @media (max-width: 1650px) {
        font-size: 16px;
        line-height: 26px;
    }
`
